import Vue from "vue";

const onClick = (el, binding) => {
  for (let key in binding.value) {
    el.style[key] = binding.value[key];
  }
};

Vue.directive("click", {
  bind(el, binding) {
    el.addEventListener("click", () => {
      onClick(el, binding);
    });
  },
  unbind: function (el) {
    el.removeEventListener("click", onClick);
  },
});

Vue.directive('overflow', (el, binding) => {
  if (binding.arg === 'width') {
    el.style.width = binding.value || '100%'
  }
  if (binding.arg === 'maxWidth') {
    el.style.maxWidth = binding.value
  }
  if(binding.modifiers.nowrap) {
      el.classList.add('single-line')
  }
  if(binding.modifiers.inlineBlock) {
      el.style.display = 'inline-block'
  }
})
